import React from 'react'
import PropTypes from 'prop-types'
import {Stack, Text} from '@chakra-ui/layout'
import {Button} from '@chakra-ui/react'
import {useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import A3EnergyIcon from '../icons/energy-label/A3EnergyIcon'
import A2EnergyIcon from '../icons/energy-label/A2EnergyIcon'
import A1EnergyIcon from '../icons/energy-label/A1EnergyIcon'
import AEnergyIcon from '../icons/energy-label/AEnergyIcon'
import BEnergyIcon from '../icons/energy-label/BEnergyIcon'
import CEnergyIcon from '../icons/energy-label/CEnergyIcon'
import DEnergyIcon from '../icons/energy-label/DEnergyIcon'

const EnergyLabel = ({
    description,
    level,
    manualDocument,
    labelPosition = 'top',
    iconSize = 'big',
    textWidth = 'big',
    textSize = 'big',
    width = 'unset',
    justifyContent = 'unset',
    extraStyleDescription = {},
}) => {
    const style = useMultiStyleConfig('EnergyLabel', {
        labelPosition,
        iconSize,
        textWidth,
        textSize,
        width,
        justifyContent,
    })

    const intl = useIntl()

    const levelComponents = {
        'A+++': A3EnergyIcon,
        'A++': A2EnergyIcon,
        'A+': A1EnergyIcon,
        A: AEnergyIcon,
        B: BEnergyIcon,
        C: CEnergyIcon,
        D: DEnergyIcon,
    }
    const LevelComponent = levelComponents[level]

    const manualDocumentInfo = manualDocument && JSON.parse(manualDocument)

    const energyLabelDoc = manualDocumentInfo?.find((doc) => doc?.isEnergyLabel === 'true')

    const buttonProps = energyLabelDoc?.imageLink
        ? {
              as: 'a',
              href: energyLabelDoc.imageLink,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {}

    const ariaLabel = intl.formatMessage(
        {
            id: 'energy_label.aria_label',
            defaultMessage: 'Energy efficiency {level}{clickAction}',
            description: 'Accessibility label for energy efficiency button',
        },
        {
            level,
            clickAction: energyLabelDoc?.imageLink
                ? intl.formatMessage({
                      id: 'energy_label.click_action',
                      defaultMessage: ', click to view energy label',
                  })
                : '',
        },
    )

    return (
        <Stack {...style.container}>
            <Text {...style.description} {...extraStyleDescription}>
                {description}
            </Text>
            <Button {...style.labelIcon} {...buttonProps} aria-label={ariaLabel}>
                {LevelComponent && <LevelComponent {...style.icon} />}
            </Button>
        </Stack>
    )
}

EnergyLabel.propTypes = {
    description: PropTypes.string,
    manualDocument: PropTypes.string,
    level: PropTypes.string,
    labelPosition: PropTypes.oneOf(['top', 'left']),
    iconSize: PropTypes.oneOf(['big', 'small']),
    textWidth: PropTypes.oneOf(['big', 'medium', 'small']),
    textSize: PropTypes.oneOf(['big', 'small']),
    justifyContent: PropTypes.string,
    width: PropTypes.string,
    extraStyleDescription: PropTypes.object,
}

export default EnergyLabel
